import React from 'react';

import SharedTestimonials, { TestimonialsProps } from './SharedTestimonials';

const TalkspaceTestimonials: React.FC<TestimonialsProps> = ({ setShowTestimonials }) => {
  const testimonials = [
    {
      background: '#FEC664',
      textColor: '#2e1c5b',
      boldText:
        '“My quality of life has improved thanks to Talkspace and [the] quality of therapy sessions. I would highly recommend them to anyone looking for positive experience with talk therapy.”',
      lightText: '—A real-life Talkspace user',
    },
    {
      background: '#F7E7C3',
      textColor: '#2e1c5b',
      boldText:
        '“Talkspace felt life saving this year. I loved the ability to use the messaging sessions for the challenges I experienced in between my video sessions with my therapist.”',
      lightText: '—Another actual Talkspace user',
    },
  ];

  return (
    <SharedTestimonials
      brand="talkspace"
      testimonials={testimonials}
      setShowTestimonials={setShowTestimonials}
      backgroundColor="#96C0F0"
    />
  );
};

export default TalkspaceTestimonials;
